import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import CommonHeader from "@/components/CommonHeader.vue";
import Modal from "@/components/Modal.vue";
import BeeButtons from '@/components/BeeInput.vue';
import NoCoverageModal from '@/components/NoCoverageModal.vue';
import axios from 'axios';
import { DistanceRadius } from '@/models/DeliveryMenu';
import firebase from "firebase";
let Maps = class Maps extends Vue {
    constructor() {
        super(...arguments);
        this.userLocation = false;
        this.showNoCoverage = false;
        this.zoom = 13;
        this.address = {};
        this.delivery = this.$store.state.deliveryMenu;
        this.commensalCoordinates = {
            lat: this.$store.state.deliveryMenu.location.lat,
            lng: this.$store.state.deliveryMenu.location.lng
        };
        this.commensalMarkerCoordinates = {
            lat: this.$store.state.deliveryMenu.location.lat,
            lng: this.$store.state.deliveryMenu.location.lng
        };
        this.restaurantCoordinates = {
            lat: this.$store.state.deliveryMenu.location.lat,
            lng: this.$store.state.deliveryMenu.location.lng
        };
        this.maxRadiusRestaurantRange = Math.max(this.delivery.costShipping?.radius1.distance || 0, this.delivery.costShipping?.radius2.distance || 0, this.delivery.costShipping?.radius3.distance || 0, this.delivery.costShipping?.radius4.distance || 0);
    }
    getCoordinates() {
        navigator.geolocation.getCurrentPosition(res => {
            this.commensalCoordinates.lat = res.coords.latitude;
            this.commensalCoordinates.lng = res.coords.longitude;
            this.commensalMarkerCoordinates.lat = res.coords.latitude;
            this.commensalMarkerCoordinates.lng = res.coords.longitude;
            this.userLocation = true;
        });
    }
    updateCoordinates(location) {
        this.commensalMarkerCoordinates = {
            lat: location.latLng.lat(),
            lng: location.latLng.lng(),
        };
    }
    get style() {
        return `width: ${screen.width}px; height: ${screen.height}px`;
    }
    async requestAddress() {
        const result = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${this.commensalMarkerCoordinates.lat},${this.commensalMarkerCoordinates.lng}&key=${process.env.VUE_APP_GOOGLEMAPS_KEY}`);
        const data = result.data.results[0];
        this.address.extNumber = await this.parseAddress(data, 'number');
        this.address.street = await this.parseAddress(data, 'street');
        this.address.region = await this.parseAddress(data, 'region');
        this.address.locality = await this.parseAddress(data, 'locality');
        this.address.state = await this.parseAddress(data, 'state');
        this.address.country = await this.parseAddress(data, 'country');
        this.address.postal = await this.parseAddress(data, 'postal');
        this.address.location = new firebase.firestore.GeoPoint(this.commensalMarkerCoordinates.lat, this.commensalMarkerCoordinates.lng);
        this.$store.dispatch('setAddress', this.address);
        if (this.address.location) {
            const distance = this.haversineFormula(this.address.location.latitude, this.address.location.longitude);
            const inRange = this.inRange(distance);
            inRange ? await this.$router.push('/deliveryform') : this.showNoCoverage = true;
        }
        else {
            this.showNoCoverage = true;
        }
    }
    inRange(distance) {
        const radius1 = this.$store.state.deliveryMenu.costShipping[DistanceRadius.RADIUS1].distance;
        const radius2 = this.$store.state.deliveryMenu.costShipping[DistanceRadius.RADIUS2].distance;
        const radius3 = this.$store.state.deliveryMenu.costShipping[DistanceRadius.RADIUS3].distance;
        const radius4 = this.$store.state.deliveryMenu.costShipping[DistanceRadius.RADIUS4].distance;
        if (distance <= radius1 && distance > 0) {
            this.$store.state.order.deliveryCost = this.$store.state.deliveryMenu.costShipping[DistanceRadius.RADIUS1].cost;
            return true;
        }
        else if (distance <= radius2) {
            this.$store.state.order.deliveryCost = this.$store.state.deliveryMenu.costShipping[DistanceRadius.RADIUS2].cost;
            return true;
        }
        else if (distance <= radius3) {
            this.$store.state.order.deliveryCost = this.$store.state.deliveryMenu.costShipping[DistanceRadius.RADIUS3].cost;
            return true;
        }
        else if (distance <= radius4) {
            this.$store.state.order.deliveryCost = this.$store.state.deliveryMenu.costShipping[DistanceRadius.RADIUS4].cost;
            return true;
        }
        return false;
    }
    haversineFormula(latUser, lngUser) {
        const latRest = this.$store.state.deliveryMenu.location.lat;
        const lngRest = this.$store.state.deliveryMenu.location.lng;
        const R = 6371;
        const dLat = this.deg2rad(latUser - latRest);
        const dLon = this.deg2rad(lngUser - lngRest);
        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(this.deg2rad(latRest)) * Math.cos(this.deg2rad(latUser)) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c * 1000;
    }
    deg2rad(deg) {
        return deg * (Math.PI / 180);
    }
    async parseAddress(data, ref) {
        const typeData = {
            number: ["street_number"],
            street: ["street_address", "route"],
            region: [
                "political",
                "sublocality",
                "sublocality_level_1",
                "sublocality_level_2",
                "sublocality_level_3",
                "sublocality_level_4"
            ],
            locality: ["locality"],
            state: [
                "administrative_area_level_1",
                "administrative_area_level_2",
                "administrative_area_level_3",
                "administrative_area_level_4",
                "administrative_area_level_5"
            ],
            country: ["country"],
            postal: ["postal_code"],
        };
        let res = '';
        data.address_components.forEach(component => {
            for (const type in typeData) {
                if (typeData[type].indexOf(component.types[0]) !== -1) {
                    if (type === ref) {
                        res = component.long_name;
                    }
                }
            }
        });
        return res;
    }
};
Maps = __decorate([
    Component({
        components: {
            CommonHeader,
            Modal,
            BeeButtons,
            NoCoverageModal
        }
    })
], Maps);
export default Maps;
